/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 *
 * @param {string} url
 * @returns {boolean}
 */
module.exports = function isObjectURL(url) {
  return url.indexOf('blob:') === 0;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/isObjectURL.js
// module id = 1237
// module chunks = 0